/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBusinessObjects = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m11.49 2.211 3.64 3.82-3.64 3.818-1.387-1.457L11.429 7H6v2.172a3.016 3.016 0 0 1 1.828 1.827H18.27l-1.297-1.361 1.388-1.457L22 12l-3.639 3.819-1.388-1.457L18.27 13H7.829A3.016 3.016 0 0 1 6 14.83V17h5.429l-1.326-1.392 1.388-1.457 3.638 3.819-3.638 3.819-1.388-1.457 1.268-1.333L4 19v-4.171C2.836 14.416 2 13.304 2 12s.836-2.416 2-2.829V5h7.371l-1.268-1.332zM5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBusinessObjects as BusinessObjects };
